import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';

import scss from './BackupFilters.module.scss';

function BackupFilters({ onReclaim }) {
  const { t } = useTranslation('id8');
  const dispatch = useDispatch();

  const { id } = useParams();

  const handleReclaimBackup = () => {
    dispatch(onReclaim(id));
  };

  return (
    <div className={scss.filtersWrapper}>
      <CommonButton styleColor={BUTTON_STYLES.SECONDARY} maxWidth={150} onClick={handleReclaimBackup}>
        {t('reclaimBackup')}
        <Icon icon={ICONS.RoundArrow} disableCommonColors className={scss.reclaimIcon} />
      </CommonButton>
    </div>
  );
}

export default BackupFilters;
